
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Arbeitsplatz from '@/types/Arbeitsplatz';
    import { confirmSwal } from '@/helper/swals';
    import { SweetAlertResult } from 'sweetalert2';
    import { VForm } from '@/types/Components';
    import { SystemEinstellung, SystemEinstellungKey } from '@/types/Einstellung';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('arbeitsplaetze', ['loaders', 'printers']),
            ...mapState('authentication', ['impfstelle_id']),
            ...mapState('cards', ['cards']),
            ...mapState('cards', { cardsLoaders: 'loaders' }),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('arbeitsplaetze', ['updateArbeitsplatz', 'deleteArbeitsplatz', 'loadPrinters']),
            ...mapActions('cards', ['loadCards']),
        },
    })
    export default class ArbeitsplaetzeDetail extends Vue {
        @Prop() arbeitsplatz!: Arbeitsplatz;
        @Prop() visible!: boolean;

        public impfstelle_id!: number;
        public updateArbeitsplatz!: (arbeitsplatz: Arbeitsplatz) => void;
        public deleteArbeitsplatz!: (arbeitsplatz: Arbeitsplatz) => void;
        public loadPrinters!: () => void;
        public loadCards!: () => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;

        public $refs!: {
            form: VForm;
        };

        public get isEdit(): boolean {
            return this.arbeitsplatz.arbeitsplatz_id !== null;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }

                this.$nextTick(() => {
                    this.loadPrinters();
                    this.loadCards();
                });
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.arbeitsplatz.impfstelle_id = this.impfstelle_id;
                this.updateArbeitsplatz(this.arbeitsplatz);
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Arbeitsplatz endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteArbeitsplatz(this.arbeitsplatz);
                    }
                });
        }
    }
